﻿import * as $ajax from './_ajax'
import * as $loading from './_loading'
import * as $msg from './_msg'

export function bindToggleFlagEvents(targetElement:JQuery) : void {
    targetElement.find(".bcfla-flag-toggle").click(function () {
        var label = $(this);

        if (label.hasClass("bcfla-label-disabled")) return;

        toggleFlag(
            parseInt(label.attr("data-ownerid")),
            parseInt(label.attr("data-propid")),
            parseInt(label.attr("data-flagid")),
            function (res) {
                if (res.IsFlagged) {
                    label.removeClass("bcfla-label-unchecked");
                }
                else {
                    label.addClass("bcfla-label-unchecked");
                }
            }
        );
    });

    targetElement.find(".bcfla-flagicon-toggle").click(function () {
        var label = $(this);

        if (label.hasClass("bcfla-flagicon-disabled")) return;

        var uncheckedClass:string = label.parent().attr("data-unchecked-class");
        var checkedClass:string = label.parent().attr("data-checked-class");

        toggleFlag(
            parseInt(label.attr("data-ownerid")),
            parseInt(label.attr("data-propid")),
            parseInt(label.attr("data-flagid")),
            function (res) {
                if (res.IsFlagged) {
                    label.html("<span class='" + checkedClass + "'></span>");
                }
                else {
                    label.html("<span class='" + uncheckedClass + "'></span>");
                }
            }
        );
    });
}

function toggleFlag(ownerId:number, propId:number, flagId:number, onComplete:any) : void {
    $ajax.post({
        loadingText: "Flaggar...",
        url: "/Flag/Toggle",
        data: {
            ownerId: ownerId,
            propertyId: propId,
            flagId: flagId
        },
        success: function (res) {
            onComplete(res);
        }
    });
}

export module edit {
}
